<script setup></script>

<template>
  <RouterView />
</template>

<style></style>
